import { requirePermission } from '@/utils/auth'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { CITY_NAME } from '@/meta'

export const Route = createFileRoute('/drivers')({
  beforeLoad: ({ location }) => {
    requirePermission('drivers')
    const defaultFilter = CITY_NAME.toLowerCase() === 'prague' ? 'all' : 'internal'

    if (location.pathname === '/drivers' || location.pathname === '/drivers/') {
      throw redirect({
        to: '/drivers/$filter',
        params: {
          filter: defaultFilter,
        },
      })
    }
  },
})
